module.exports = __webpack_public_path__ + "assets/img/dfa-ia.3d1d86e9.png";